import { InputDatePicker } from '@insurance/components'
import { useValidationsField } from '@insurance/hooks'
import { InputParsedNumber } from '@shared/components'
import { Col, Form, Row } from 'antd'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

import { CoefficientInput } from './CoefficientInput'
import { formProps } from './utils'

export const MainStep = () => {
  const { t } = useTranslation()
  const { required } = useValidationsField()

  const { validFromProps, validToProps, personsCountProps } = formProps(t)

  const validFrom = Form.useWatch(validFromProps.name, { preserve: true })
  const validTo = Form.useWatch(validToProps.name, { preserve: true })

  return (
    <Row gutter={12}>
      <Col xs={24} lg={12}>
        <Form.Item {...validFromProps} rules={[required]}>
          <InputDatePicker
            placeholder={validFromProps.label}
            minDate={dayjs()}
            maxDate={validTo ? dayjs(validTo) : undefined}
            allowClear={false}
          />
        </Form.Item>
      </Col>

      <Col xs={24} lg={12}>
        <Form.Item {...validToProps} rules={[required]}>
          <InputDatePicker
            placeholder={validToProps.label}
            minDate={validFrom ? dayjs(validFrom) : dayjs()}
            allowClear={false}
          />
        </Form.Item>
      </Col>

      <Col xs={24} lg={12}>
        <Form.Item {...personsCountProps} rules={[required]}>
          <InputParsedNumber
            className="w-full"
            placeholder={personsCountProps.label}
            min={1}
          />
        </Form.Item>
      </Col>

      <Col xs={24} lg={12}>
        <CoefficientInput />
      </Col>
    </Row>
  )
}
